import axios from 'axios';
import { Helpers } from '../helpers/Helpers';
import { GetNeighborhoodListPagingAndFilterRequest } from '../models/request/neighborhood/GetNeighborhoodListPagingAndFilterRequest';

export class NeighborhoodService {
    static async getNeighborhoodListPagingAndFilter(inputObj: GetNeighborhoodListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - GetNeighborhoodListPagingAndFilter', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Neighborhood/GetNeighborhoodListPagingAndFilter', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async exportNeighborhoodList(inputObj: GetNeighborhoodListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - exportNeighborhoodList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Neighborhood/exportNeighborhoodList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getNeighborhoodById(_id: string) {
        try {
            var inputObj = {
                id: _id
            };

            console.log('SERVICE CALL - getNeighborhoodById', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Neighborhood/getNeighborhoodById', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }
}